module.exports = __webpack_public_path__ + "img/Freespin_h1.1bcb8e64.png";